import moment from "moment";
import {ElMessage, ElMessageBox} from "element-plus";
import {FORM_ITEM_TYPES, MODEL_COLUMN_TYPE, PARAM_TYPE, SPREAD_SHEET_TYPE} from "@/option/common/dict.js";
import {Engine} from "json-rules-engine";
import {appService} from "@/option/common/dao";
import {computed, unref} from "vue";
import {website} from "@/config";

let defaultColors = [
  ["#0189fd", "#fe9204", "#11aa50", "#ffd003", "#7262ed", "#69c4eb", "#6c738e", "#ff745b", "#007d99", "#ffa8a8"],
  ["#016dcb", "#017ae4", "#0189fd", "#33a1ff", "#4eabfe", "#66b8fe", "#7fc3fe", "#9acfff", "#cce6fe", "#e5f3fe"],
  ["#ff2c43", "#ff9c6f", "#feccb4", "#fcdca5", "#fcc664", "#cb9742", "#8e736b"],
  ["#008cfa", "#00bbf6", "#6fdeec", "#58edec", "#30d8bf", "#00c5aa", "#2ba3a5"],
  [
    "#188efc",
    "#3ed0be",
    "#2dbb58",
    "#95de59",
    "#f1c513",
    "#de9159",
    "#21306e",
    "#7160c5",
    "#8141d9",
    "#5a8be1",
    "#12bbbb",
    "#12bdbd",
    "#599dde",
    "#3335c2",
    "#9a7cde",
    "#e94661",
    "#c93ed0",
  ],
  [
    "#00A2FF",
    "#00EAFF",
    "#12E7A3",
    "#55C5F4",
    "#5A5CE3",
    "#64E302",
    "#0C0159",
    "#0C0159",
    "#F2A741",
    "#A542F2",
  ],
];
const UNIT_MAP = {
  '1': '',
  '1000': '千',
  '10000': '万',
  '1000000': '百万',
  '100000000': '亿',
  '1000000000000': '兆',
}
const operatorMap = {
  '=': 'equal',
  '<>': 'notEqual',
  '>=': 'greaterThanInclusive',
  '<=': 'lessThanInclusive',
  '>': 'greaterThan',
  '<': 'lessThan',
  'and': 'all',
  'or': 'any',
}
export default {
  EXIT_CODE: -1,
  index: 1,
  default__(v) {
    if (!v && v !== 0) {
      return '--'
    }
    return v
  },
  getIndex: function () {
    var str = new Date().getTime() + "" + this.paddingNum(this.index++, 3);
    if (this.index > 999) {
      this.index = 1;
    }
    return str;
  },
  getComponentDom(ref) {
    return document.getElementById(ref);
  },
  paddingNum: function (num, length) {
    return (Array(length).join("0") + num).slice(-length);
  },
  message: ElMessage,
  confirm: ElMessageBox.confirm,
  getObjById(list, id, key) {
    //判断list是否是数组
    if (!list instanceof Array) {
      return null;
    }
    //遍历数组
    for (let i in list) {
      let item = list[i];
      if (item[key] === id) {
        return item;
      } else {
        //查不到继续遍历
        if (item.children) {
          let value = this.getObjById(item.children, id, key);
          //查询到直接返回
          if (value) {
            return value;
          }
        }
      }
    }
  },
  isEmpty: function (obj) {
    if (obj == undefined || obj == null) {
      return true;
    }
    if (typeof obj == "string") {
      return obj.length == 0;
    }
    if (obj instanceof Array) {
      return obj.length == 0;
    }
  },
  isCode: function (str) {
    var reg = /^[a-zA-Z]{1}\w*$/;
    return reg.test(str);
  },
  isNumber: function (str) {
    var reg = /^(\-|\+)?\d+(\.\d+)?$/;
    return reg.test(str);
  },
  getObjectFromOption: function (attrs) {
    var ret = {};
    attrs.forEach((attr) => {
      var value = attr.value;
      if (attr.type == "object") {
        if (attr.children) {
          value = this.getObjectFromOption(attr.children);
        } else {
          value = {};
        }
      }
      // 数组直接用json解析
      try {
        if (attr.type === "array" && attr.value) {
          value = new Function(`return ${attr.value}`)();
        }
      } catch (e) {
        console.log(e);
      }
      ret[attr.key] = value;
    });
    return ret;
  },
  /**
   * @method vite动态引入图片
   * @params folder 文件夹名称 name 文件名称 type 文件格式 一般为png/jpg/webp/gif等...
   * @returns String
   */
  useImageUrl(path) {
    if (path == "") {
      return undefined;
    }
    // const url =  await import(`@/assets/${path}`).catch(err=>err)
    // console.log('testimg',url)
    // return url.default
    return ''
    // return new URL(`../../assets/${path}`, import.meta.url).href;
  },
  updateReactiveKeys(source, target) {
    for (const rowKey in source) {
      target[rowKey] = source[rowKey];
    }
  },
  debounce(func, wait, option) {
    if (!option) {
      option = {leading: false, trailing: true};
    }
    // in basic debounce, we kept only timerId
    // here, we will keep lastArgs too as we trailing function call with last arguments
    let timerId = null;
    let lastArgs = null;

    // if both leading and trailing are false then do nothing.

    if (!option.leading && !option.trailing) return () => null;

    return function debounced(...args) {
      // if timer is over and leading is true
      // then immediately call supplied function
      // else capture arguments in lastArgs
      if (!timerId && option.leading) {
        func.apply(this, args);
      } else {
        lastArgs = args;
      }

      // clear timer so that next call is exactly after `wait` time
      clearTimeout(timerId);

      timerId = setTimeout(() => {
        // invoke only if lastArgs is present and trailing is true
        if (option.trailing && lastArgs) func.apply(this, lastArgs);

        // reset variables as they need to restart new life after calling this function
        lastArgs = null;
        timerId = null;
      }, wait);
    };
  },
  // 指定长度和基数
  getUUID(len, radix) {
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
    var uuid = [],
      i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4";

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }

    return uuid.join("");
  },
  getDate(date) {
    if (date) {
      return moment(date).format("YYYY-MM-DD");
    }
    return "";
  },
  getRefId() {
    return "ref_" + this.getIndex();
  },
  // 添加仅用于drop的子组件
  getDropChildConfig(obj) {
    return {
      ref: this.getRefId(),
      name: "容器",
      componentCode: "vlayout",
      classes: ["pos-r"],
      children: [],
      styles: obj?.styles || {},
      prop: obj?.prop || {},
    };
  },
  getDateTime(date) {
    if (date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    }
    return "";
  },
  //  获取多层绑定的parent
  getDeepParent(obj, key) {
    let list = key.split(".");
    if (list.length > 1) {
      let parentKey = list.join(".");
      return this.deepGet(obj, parentKey);
    } else {
      return obj
    }
  },
  getSetColors(index) {
    return defaultColors[index];
  },
  // attr在form循环配置的时候需要 for循环一定记得传 不然拿不到值
  deepGet(obj, keys, defaultVal, attr, pageParam, linkData) {
    if (!keys) {
      return "";
    }
    // 这种情况下是新版绑定的变量 区分类型 之前只绑定变量是个string
    if (typeof keys === "object") {
      if (keys.type === PARAM_TYPE.VARIABLE || keys.type === PARAM_TYPE.COMPUTED) {
        // 在走到最后面的return
        keys = keys.key;
      } else if (keys.type === PARAM_TYPE.PAGE) {
        // 页面入参暂时只有一层 多层后面再说
        return pageParam[keys.key];
      } else if (keys.type === PARAM_TYPE.LOOP) {
        // 因为存在多层嵌套问题 如 item.a.b.c.d 直接拼接字符串通过eval解析 省的递归了
        let _valStr = `attr.${keys.key}`;
        try {
          _valStr = eval(_valStr);
        } catch (e) {
          _valStr = "";
          console.log(e);
        }
        return _valStr;
      } else if (keys.type === PARAM_TYPE.LINK) {
        return this.deepGet(linkData, keys.key)?.value;
      }
    }
    return (
      (!Array.isArray(keys) ? keys.replace(/\[/g, ".").replace(/\]/g, "").split(".") : keys).reduce(
        (o, k) => (o === null || o === undefined ? {} : o)[k],
        obj,
      ) ?? defaultVal
    );
  },
  /**
   * 在页面编排阶段拿到data的值
   * @param key
   * @param defaultV
   */
  deepGetEditStatus(data, key, defaultV) {
    if (!key) return "";

    if (!data) {
      data = window.KSPageConfig.value.schemaJson.datas;
    }
    let keys = key.split(".");
    let firstKey = keys[0];
    let item = data.find((el) => el.key === firstKey);

    if (keys.length === 1) {
      return item.value;
    } else if (keys.length > 1) {
      keys.shift();
      return this.deepGetEditStatus(item.children, keys.join("."), defaultV);
    }
  },
  /**
   * 在页面编排阶段拿到data的原始值
   * @param key
   * @param defaultV
   */
  deepGetDataEditStatus(data, key, defaultV) {
    if (!key) return "";

    if (!data) {
      data = window.KSPageConfig.value.schemaJson.datas;
    }
    let keys = key.split(".");
    let firstKey = keys[0];
    let item = data.find((el) => el.key === firstKey);

    if (keys.length === 1) {
      return item;
    } else if (keys.length > 1) {
      keys.shift();
      return this.deepGetDataEditStatus(item.children, keys.join("."), defaultV);
    }
  },
  // 根据页面参数的key 获取名称
  getBindKeyName(data, key) {
    if (!key) return "";
    if (!data) {
      data = window.KSPageConfig.value.schemaJson.datas;
    }
    let keys = key.split(".");
    let firstKey = keys[0];
    let item = data.find((el) => el.key === firstKey);

    if (keys.length === 1) {
      return item?.label;
    } else if (keys.length > 1) {
      keys.shift();
      return this.deepGetEditStatus(item.children, keys.join("."), defaultV);
    }
  },
  // 运行态获取绑定或者循环变量
  getRunBindOrLoopData(loopKey, bindKey, attr) {
    if (loopKey) {
      // 因为存在多层嵌套问题 如 item.a.b.c.d 直接拼接字符串通过eval解析 省的递归了
      let _valStr = `attr.${loopKey}`;
      try {
        _valStr = eval(_valStr);
      } catch (e) {
        _valStr = "文字";
        console.log(e);
      }
      return _valStr;
    } else {
      return this.deepGet(null, bindKey, "");
    }
  },
  // 获取循环的数据或者绑定的数据源数据  循环数据通过attr传参
  getBindOrLoopData(loopKey, bindKey, attr) {
    if (loopKey) {
      // 因为存在多层嵌套问题 如 item.a.b.c.d 直接拼接字符串通过eval解析 省的递归了
      let _valStr = `attr.${loopKey}`;
      try {
        _valStr = eval(_valStr);
      } catch (e) {
        _valStr = "";
        console.log(e);
      }
      return _valStr;
    } else {
      return this.deepGetEditStatus(null, bindKey, "");
    }
  },
  isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]'
  },
  delEmptyKey(form) {
    for (const formKey in form) {
      let val = form[formKey];
      if (val === "" || val === undefined || val === null || JSON.stringify(val) === "{}") {
        delete form[formKey];
      }
    }
  },
  /**
   *
   * @param list 待转换数组
   * @param rowKey 自己的id
   * @param pKey 爸爸id 如parentId
   * @param rootValue 根节点默认值 不传默认为不存在
   * @returns {*[]}
   */
  convert(list, rowKey, pKey, rootValue) {
    const res = [];
    const map = list.reduce((res, v) => ((res[v[rowKey]] = v), res), {});
    for (const item of list) {
      if (rootValue ? item[pKey] === rootValue : !item[pKey]) {
        res.push(item);
        continue;
      }
      if (item[pKey] in map) {
        const parent = map[item[pKey]];
        parent.children = parent.children || [];
        parent.children.push(item);
      }
    }
    return res;
  },
  mergeObjectKey(source, target) {
    for (const sourceKey in source) {
      target[sourceKey] = source[sourceKey];
    }
  },
  getBizOptions(type) {
    switch (type) {
      case "String":
        return [
          {
            name: "地理位置",
            value: "location",
          },
          {
            name: "电子邮件",
            value: "email",
          },
          {
            name: "电话",
            value: "phone",
          },
          {
            name: "文本",
            value: "text",
          },
          {
            name: "超链接",
            value: "link",
          },
          {
            name: "富文本",
            value: "richText",
          },
          {
            name: "上传附件",
            value: "upload",
          },
          {
            name: "上传图片",
            value: "uploadImg",
          },
        ];
      case "Number":
        return [
          {
            name: "货币",
            value: "currency",
          },
          {
            name: "百分比",
            value: "percentage",
          },
          {
            name: "评分",
            value: "rate",
          },
        ];
      case "Date":
        return [
          {
            name: "日期",
            value: "date",
          },
          {
            name: " 时间",
            value: "time",
          },
          {
            name: "日期时间",
            value: "datetime",
          },
        ];
      case "Dict":
        return [
          {
            name: "下拉",
            value: "Dict",
          },
        ];
      case "State":
        return [
          {
            name: "状态",
            value: "State",
          },
        ];
      case "Ref":
        return [
          {
            name: "内部引用",
            value: "Ref",
          },
        ];
      case "ExteriorRef":
        return [
          {
            name: "外部引用",
            value: "ExteriorRef",
          },
        ];
      case "Boolean":
        return [
          {
            name: "开关",
            value: "Boolean",
          },
          {
            name: "复选框",
            value: "checkbox",
          },
        ];
      case "Assignee":
        return [
          {
            name: "处理人",
            value: "Assignee",
          },
        ];
      default:
        return FORM_ITEM_TYPES.list;
    }
  },
  getFormItemConfig(config = {}) {
    return {
      selected: config.selected ?? true,
      appId: config?.appId,
      version: config?.version,
      // 引用类型支持组件类型 属性下拉或者弹窗
      refSupType: config?.refSupType,
      id: "f-" + this.getIndex(),
      name: config?.fieldName,
      modelFieldId: config.modelFieldId,
      key: config?.fieldKey || "key" + this.getUUID(4),
      // 业务组件类型 可能没有
      type: config?.modelBizType || this.getDefaultType(config?.modelFieldType),
      // 字段类型
      modelFieldType: config?.modelFieldType,
      fieldType: config.fieldType || "string",
      span: 1,
      tips: "",
      required: config?.required === 1 ? true : false,
      strLength: config?.strLength || 0,
      regularExpr: config?.regularExpr,
      valueRuleConfig: config?.valueRule,
      dictKey: "",
      labelWidth: null,
      display: true,
      inline: true,
      minRange: config?.minRange,
      maxRange: config?.maxRange,
      startDate: config?.startDate,
      endDate: config?.endDate,
      // 这个因为后台单词拼错了 应该是 digits
      digist: config?.digist,
    };
  },
  getDefaultType(type) {
    // THIS KIND OF XXX CODE
    switch (type) {
      case MODEL_COLUMN_TYPE.string:
        return "text";
      case MODEL_COLUMN_TYPE.number:
        return "number";
      case MODEL_COLUMN_TYPE.ref:
        return "tree";
      case MODEL_COLUMN_TYPE.date:
        return "date";
      case MODEL_COLUMN_TYPE.dict:
        return "Dict";
      case MODEL_COLUMN_TYPE.assignee:
        return "list";
      case MODEL_COLUMN_TYPE.bool:
        return "Boolean";
      case MODEL_COLUMN_TYPE.exRef:
        return "tree";
      case MODEL_COLUMN_TYPE.orgunit:
        return "list";
      default:
        return "text";
    }
  },
  getQueryItemConfig(config = {}) {
    return {
      selected: config.selected ?? true,
      appId: config?.appId,
      version: config?.version,
      // 引用类型支持组件类型 属性下拉或者弹窗
      refSupType: config?.refSupType,
      id: "f-" + this.getIndex(),
      name: config?.fieldName,
      key: config?.fieldKey || "key" + this.getUUID(4),
      display: true,
      // 业务组件类型 可能没有
      type: config?.modelBizType,
      // 模型字段类型
      modelFieldType: config?.modelFieldType,
      fieldType: config.fieldType || "string",
      valueRuleConfig: config?.valueRule,
    };
  },
  getColumnItemConfig(config = {}) {
    return {
      selected: config.selected ?? true,
      appId: config?.appId,
      version: config?.version,
      // 引用类型支持组件类型 属性下拉或者弹窗
      refSupType: config?.refSupType,
      id: "f-" + this.getIndex(),
      name: config?.fieldName || "",
      key: config?.fieldKey || "key" + this.getUUID(4),
      display: true,
      sortable: true,
      resizable: true,
      // 业务组件类型 可能没有
      type: config?.modelBizType,
      // 模型字段类型
      modelFieldType: config?.modelFieldType,
      fieldType: config.fieldType || "string",
      "show-overflow-tooltip": true,
      color: "#606266",
      progress: {
        textInside: false,
        strokeWidth: 16,
        color: "#67c23a",
      },
      valueRuleConfig: config?.valueRule,
      // popoverConfig: {
      // 	appId: "",
      // 	serviceId: "",
      // 	width: 800,
      // 	columns: [],
      // 	queryList: [],
      // 	dao: {
      // 		pagePath: "",
      // 	},
      // 	table: {
      // 		showIndex: true,
      // 	},
      // 	query: {
      // 		colNumber: 3,
      // 	},
      // },
    };
  },
  loadStyle(code) {
    let id = "ks-cus-style";
    let style = document.getElementById(id);
    if (!style) {
      style = document.createElement("style");
      style.rel = "stylesheet";
      style.id = id;
    } else {
      style.innerText = "";
    }
    style.appendChild(document.createTextNode(code));
    let head = document.getElementsByTagName("head")[0];
    head.appendChild(style);
  },
  uniqueArray(arr, keyList) {
    const map = new Map();
    const uniqueArr = [];
    for (const item of arr) {
      let key = keyList.map((el) => item[el]).join();
      if (!map.has(key)) {
        map.set(key, true);
        uniqueArr.push(item);
      }
    }
    return uniqueArr;
  },
  // 注入函数 默认传三个参数
  funcFromString(funcString, params, useDefault = false) {
    try {
      let defaultParam = ["vue", "componentsMap", "datas"];
      if (!params) {
        //  使用默认参数
        params = defaultParam;
      } else if (params && useDefault) {
        // 在默认参数基础上增加参数
        params = defaultParam.concat(params);
      }
      //  componentsMap为所有组件实例map datas 为全局数据
      return new Function(...params, funcString);
    } catch (e) {
      console.log(e);
    }
  },
  /**
   * 表单规则函数 最后一个参数默认传form
   * @param funcString
   * @param paramName
   * @returns {Function}
   */
  ruleFuncFromString(funcString, paramName = "$form") {
    try {
      //  componentsMap为所有组件实例map datas 为全局数据 暂时只提示暴露$form 对象 其他的参数看后面需不需要，先传过去再说
      return new Function("vue", "componentsMap", "datas", paramName, `return ${funcString}`);
    } catch (e) {
      console.log(e);
    }
  },
  // 对生成的函数进行一个包装
  funcWrapWithError(func, ...args) {
    return () => {
      this.callWithError(func, ...args);
    };
  },
  // 执行函数
  callWithError(func, ...args) {
    if (func) {
      try {
        return func(...args);
      } catch (e) {
        console.log(e);
      }
    }
  },
  firstCapital(str) {
    return str[0].toUpperCase() + str.substring(1);
  },
  async parseRenderRule(el, data = {}) {
    let rule = el.showRule;
    const facts = {};
    let conditions = {};
    conditions[rule.operationSymbol] = rule.rows.map((el) => {
      facts[el.key] = this.deepGet(data, el.key);

      return {
        fact: el.key,
        operator: el.oper,
        value: el.fixedValue,
      };
    });
    const engine = new Engine();
    engine.addRule({
      conditions,
      event: {
        // define the event to fire when the conditions evaluate truthy
        type: "render",
        params: {
          render: true,
        },
      },
    });
    const {events} = await engine.run(facts);
    el._renderRuleRes = false;
    events.map((event) => {
      el._renderRuleRes = true;
    });
  },
  async parseSignRule(rule, data = {}, callBack) {
    const facts = {};
    let conditions = {};
    try {
      console.log('rule,', rule)
      conditions[operatorMap[rule?.operationSymbol]] = rule.rows?.map((el) => {
        facts[el.fieldMap.code] = this.deepGet(data, el.fieldMap.code);
        return {
          fact: el.fieldMap.code,
          operator: operatorMap[el.oper],
          value: el.fixedValue,
        };
      });
    } catch (err) {
      console.log(err)
    }
    const engine = new Engine();
    try {
      engine.addRule({
        conditions,
        event: {
          type: "render",
          params: {
            render: true,
          },
        },
      });
    } catch (err) {
      console.log(err)
    }
    const {events} = await engine.run(facts);
    if (events.length) {
      callBack('match')
      return 'match'
    } else {
      callBack('unmatch')
      return 'unmatch'
    }
  },
  async parseMetricCardRule(rule, dataItem, callBack) {
    const facts = {};
    let conditions = {};
    try {
      conditions[operatorMap[rule?.operationSymbol]] = rule.rows.map((el) => {
        facts[dataItem.code] = dataItem.value
        return {
          fact: dataItem.code,
          operator: operatorMap[el.oper],
          value: el.fixedValue,
        };
      });
    } catch (err) {
      console.log(err)
    }
    const engine = new Engine();
    try {
      engine.addRule({
        conditions,
        event: {
          type: "render",
          params: {
            render: true,
          },
        },
      });
    } catch (err) {
      console.log(err)
    }
    const {events} = await engine.run(facts);
    if (events.length) {
      callBack('match')
      return 'match'
    } else {
      callBack('unmatch')
      return 'unmatch'
    }
  },
  getNumberSplit(data) {
    if (!data) return "0";
    // 将数据分割，保留两位小数
    //data= data.toFixed(2)
    // 获取整数部分
    const intPart = Math.trunc(Number(data));
    // 整数部分处理，增加,
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    // 预定义小数部分
    let floatPart = "";
    // 将数据分割为小数部分和整数部分
    const newArr = data.toString().split(".");
    if (newArr.length === 2) {
      // 有小数部分
      floatPart = newArr[1].toString(); // 取得小数部分
      return intPartFormat + "." + floatPart;
    }
    return intPartFormat + floatPart;
  },
  getOperatorByType(type) {
    switch (type) {
      case MODEL_COLUMN_TYPE.string:
        return [
          {
            name: "等于",
            value: "=",
          },
          {
            name: "不等于",
            value: "<>",
          },

          {
            name: "包含",
            value: "in",
          },

          {
            name: "不包含",
            value: "not in",
          },

          {
            name: "左匹配",
            value: "left like",
          },

          {
            name: "匹配",
            value: "Like",
          },

          {
            name: "为空",
            value: "is null",
          },

          {
            name: "不为空",
            value: "is not null",
          },
        ];
      case MODEL_COLUMN_TYPE.number:
        return [
          {
            name: "等于",
            value: "=",
          },
          {
            name: "不等于",
            value: "<>",
          },

          {
            name: "包含",
            value: "in",
          },

          {
            name: "不包含",
            value: "not in",
          },
          {
            name: "为空",
            value: "is null",
          },

          {
            name: "不为空",
            value: "is not null",
          },

          {
            name: "大于",
            value: ">",
          },

          {
            name: "小于",
            value: "<",
          },

          {
            name: "大于等于",
            value: ">=",
          },

          {
            name: "小于等于",
            value: "<=",
          },

          {
            name: "闭区间",
            value: "[a,b]",
          },
        ];
      case MODEL_COLUMN_TYPE.bool:
        return [
          {
            name: "等于",
            value: "=",
          },
        ];
      case MODEL_COLUMN_TYPE.dict:
        return [
          {
            name: "等于",
            value: "=",
          },
          {
            name: "不等于",
            value: "<>",
          },

          {
            name: "包含",
            value: "in",
          },

          {
            name: "不包含",
            value: "not in",
          },
          {
            name: "为空",
            value: "is null",
          },

          {
            name: "不为空",
            value: "is not null",
          },
        ];
      case MODEL_COLUMN_TYPE.date:
        return [
          {
            name: "等于",
            value: "=",
          },
          {
            name: "为空",
            value: "is null",
          },

          {
            name: "不为空",
            value: "is not null",
          },
          {
            name: "大于",
            value: ">",
          },

          {
            name: "小于",
            value: "<",
          },

          {
            name: "大于等于",
            value: ">=",
          },

          {
            name: "小于等于",
            value: "<=",
          },

          {
            name: "闭区间",
            value: "[a,b]",
          },

          {
            name: "周期",
            value: "[a,b]",
          },
        ];
      default:
        return [
          {
            name: "等于",
            value: "=",
          },
          {
            name: "为空",
            value: "is null",
          },

          {
            name: "不为空",
            value: "is not null",
          },
          {
            name: "大于",
            value: ">",
          },

          {
            name: "小于",
            value: "<",
          },

          {
            name: "大于等于",
            value: ">=",
          },

          {
            name: "小于等于",
            value: "<=",
          },
        ];
    }
  },
  changeToComponentData(fp, keyCode) {
    let newFp = {
      id: fp.id,
      operationSymbol: fp.operationSymbol,
      rows: [],
    };
    fp[keyCode]?.forEach((gf) => {
      let nb = JSON.parse(JSON.stringify(gf));
      nb.ruletype = "d";
      newFp.rows.push(nb);
    });
    fp.children?.forEach((child) => {
      let nb = JSON.parse(JSON.stringify(child));
      nb.ruletype = "c";
      newFp.rows?.push(this.changeToComponentData(nb, keyCode));
    });
    return newFp;
  },
  getOptionData(cfg, baseConfig = website.baseList) {
    let res
    for (let i = 0; i < baseConfig.length; i++) {
      let el = baseConfig[i]
      if ((cfg?.option?.spreadSheetType === SPREAD_SHEET_TYPE.BASIC || cfg?.option?.spreadSheetType === SPREAD_SHEET_TYPE.DETAIL) && el?.option?.option?.spreadSheetType === cfg?.option?.spreadSheetType) {
        return el?.option?.data
      } else {
        if (el?.option?.component?.name === cfg?.component?.name) {
          return el?.option?.data
        }
      }
      if (el?.children?.length) {
        res = this.getOptionData(cfg, el?.children)
        if (res) break
      }
    }
    return res
  },
  // data 页面变量 query为页面参数 linkdata为大屏联动数据
  handlerFilters(data, list, query, linkData, attrs) {
    if (list?.length) {
      list.forEach((el) => {
        if (el?.conditions?.length) {
          el.conditions = el?.conditions?.filter((_el) => _el.code);
          el?.conditions.forEach((_el) => {
            // 0816演示用 后面要去除
            // TODO 写死的
            _el.type = "dim";
            if (_el.dmList) {
              delete _el.dmList;
            }
            if (_el.valueType === "pageEntry") {
              let v;
              // 新版绑定参数 加了路由传参
              if (_el.bindParam) {
                if (_el.bindParam.type === PARAM_TYPE.PAGE) {
                  // 钻取暂时定value这个参数
                  // 跳转钻取的传参需要特殊的type
                  _el.type = "dimName";
                }
                v = this.deepGet(data, _el.bindParam, '', attrs, query, linkData)
                // 	兼容老版本
              } else if (_el.bindKey) {
                v = this.deepGet(data, _el.bindKey);
                // 	大屏
              } else if (_el.bigBindKey) {
                // 取绑定的值 什么时候赋值取决于组件本身
                v = this.deepGet(linkData, _el.bigBindKey)?.value;
              }
              //  TODO 同步爱搭null传空数组
              // 后台要求数字转换成字符串
              if (typeof v === 'number') {
                v = v.toString()
              }
              if (Array.isArray(v)) {
                v.forEach((el) => {
                  if (typeof el === 'number') {
                    el = el.toString()
                  }
                })
              }
              _el.filterValueList = Array.isArray(v) ? v : (v !== null && v !== "" && v !== undefined) ? [v] : [];
            } else {
              // 后台要求数字转换成字符串
              if (typeof _el.fixedValue === 'number') {
                _el.fixedValue = _el.fixedValue.toString()
              }
              if (!(_el?.filterValueList ?? []).length)
                _el.filterValueList = ("fixedValue" in _el && _el['fixedValue'] !== null && _el['fixedValue'] !== undefined && _el['fixedValue'] !== '') ? [_el.fixedValue] : [];
            }
          });
        }
        if (el?.children?.length) {
          this.handlerFilters(data, el.children, query, linkData);
        }
      });
    }
  },
  // 根据绑定的变量 获取值 分 爱搭变量 大屏联动数据 页面参数
  getBindValue(el, datas, linkdata, pageArgs) {
    if (el.bindParam) {
      if (el.bindParam.type === PARAM_TYPE.VARIABLE) {
        return this.deepGet(datas, el.bindParam.key);
      } else if (el.bindParam.type === PARAM_TYPE.LINK) {
        return this.deepGet(linkdata, el.bindParam.key)?.value;
      } else if (el.bindParam.type === PARAM_TYPE.PAGE) {
        return this.deepGet(pageArgs, el.bindParam.key);
      }
    }
    return null
  },
  lowCodeRequest(option, auto = true) {
    // 该接口增加页面信息字段，以便接口数据权限使用
    const urlParams = new URLSearchParams(window.location.search);
    const index = location.pathname.lastIndexOf('/')
    const _pageId = location.pathname.substring(index + 1)
    const params = {...option.data}

    params.paramMap = {
      ...(params?.paramMap ?? {}),
      _appId: urlParams.get('appid'),
      _version: urlParams.get('version'),
      _pageId,
    }
    return appService.execute(params, option.url, auto);
  },
  formatValue(set, el, key) {
    if (set) {
      if (set?.nullList?.length) {
        set.nullList.forEach((_el) => {
          // 满足替换条件就替换默认值
          if (_el === "null" && el[key] === null) {
            el[key] = set.nullValue;
          }
          if (_el === "emptyString" && el[key] === "") {
            el[key] = set.nullValue;
          }
          if (_el === "0" && el[key] === 0) {
            el[key] = set.nullValue;
          }
          if (_el === "NaN" && (`${el[key]}` === "NaN")) { // isNaN判断NaN是有问题的，传非空字符串也会返回true, 改为通过字符串判断，别又改回用isNaN了
            el[key] = set.nullValue;
          }
          if (_el === "Infinity" && (`${el[key]}` === "Infinity")) { // 同上，如果不能确保返回值一定是数字类型的处理，不要用isFinite
            el[key] = set.nullValue;
          }
          if (_el === "undefined" && el[key] === undefined) {
            el[key] = set.nullValue;
          }
        });
      }
      // 如果数字值为null 不做处理
      if ((set.type === "number" || set.type === "percent") && Number.isFinite(parseFloat(el[key]))) {
        // 单位格式化
        if (set.unit) {
          el[key] = el[key] / set.unit
        }
        if (set.type === 'percent') {
          el[key] = el[key] * 100
        }
        if ("digits" in set) {
          el[key] = typeof el[key] === "number" ? el[key].toFixed(set.digits) : parseFloat(el[key]).toFixed(set.digits);
          if (el[key] == 0) { // 处理转换后是-0的情况，避免出现-0.00
            el[key] = parseFloat(0).toFixed(set.digits)
          }
        }
        if (set.splitMark) {
          el[key] = this.getNumberSplit(el[key]);
        }
        // 在数字处理的最后，给字符串添加单位
        if (set.unit) {
          // el[key] = `${el[key]}${UNIT_MAP[set.unit]}`
          // 数据单位不在此处拼接，否则会导致计算出现NAN,11月28日和产品确认，单位只在基础配置单位处自行填写，此处只做数据处理
          el[key] = `${el[key]}`
        }
      }
      if (set.type === "date") {
        if (set.type === "date" && el[`_${key}`] !== null) {
          // 时间格式化
          if (set.dateFormat) {
            try {
              el[key] = moment(el[key]).format(set.dateFormat);
            } catch (e) {
              console.log(e);
            }
          }
        }
      }

    }
  },
  groupByData(list, dcode, gcode, mcode) {
    let map = {};
    let dimention = [];
    let group = [];
    let series = [];
    list.forEach((el) => {
      // 维度过滤
      if (!map[el[unref(dcode)]]) {
        map[el[unref(dcode)]] = [];
        dimention.push(el[unref(dcode)]);
      }
      // 分组过滤
      if (!map[el[gcode]]) {
        map[el[gcode]] = [];
        group.push(el[gcode]);
      }
    });
    group.forEach((g) => {
      let _data = [];
      dimention.forEach((dim) => {
        list.find((d) => {
          if (d[unref(dcode)] === dim && d[gcode] === g) {
            _data.push(d[mcode]);
          }
        });
      });
      series.push({
        name: g,
        data: _data,
      });
    });
    return {
      dimention,
      series,
    };
  },
  // 11月1日，龚老师确认的逻辑，当有分组时，以分组为维度
  newGroupByData(list, dcode, gcode, prop) {
    const {
      metrics,
      groups = []
    } = prop
    let map = {};
    let dimention = []; // 分组做维度
    let axisList = []; // 维度是分组里的每一个数据堆
    let series = [];
    let _dcode = unref(dcode)
    // 分组数据单位处理
    let unitIndex = (groups.find(group => group.code === gcode) || {}).set?.indexUnit;
    let dataType = 'string' // 默认返回的数据类型，在开启了tooltip展示辅助指标之后，该类型会变成object
    list.forEach((el) => {
      // 分组作为维度，区分带辅助指标和不带辅助指标的数据处理
      let dimName = typeof el[gcode] === 'object' && el[gcode]?.value ? el[gcode].value : el[gcode]
      let axisName = typeof el[_dcode] === 'object' && el[_dcode]?.value ? el[_dcode].value : el[_dcode]
      if (!map[dimName]) { // 分组做维度
        map[dimName] = [];
        dimention.push(dimName);
      }
      if (!map[axisName]) { // 维度作为数据堆
        map[axisName] = [];
        axisList.push(axisName)
      }
      if (typeof el[gcode] === 'object' && el[gcode]?.value) {
        dataType = 'object'
      }
    });
    // 先补全无数据项，后端返回数据不是完整的笛卡尔集，不做补全的话，data的数据项顺序就和分组之后的维度对不上了
    const bakList = [...list]
    const metCodeList = metrics.map(item => item.code) // 指标code
    dimention.forEach(dimName => { // 分组做维度，遍历的实际是原本的分组
      axisList.forEach(axisName => { // 分组里的维度，遍历的实际是原本的维度，分组 * 维度，即笛卡尔集
        const hasDimAndAxis = list.find(item => { // 返回的数据里是否包含该 分组-维度 的笛卡尔集数据
          if (dataType === 'object') {
            return (item[gcode].value === dimName && item[_dcode].value === axisName)
          }
          return item[gcode] === dimName && item[_dcode] === axisName
        })
        if (!hasDimAndAxis) { // 如果没有，则补一条值为0的数据，用作渲染
          let obj = {}
          metCodeList.forEach(metCode => {
            if (dataType === 'object') {
              obj[metCode] = {
                value: '0',
                assistList: [],
              }
            } else {
              obj[metCode] = '0'
            }
          })
          bakList.push({
            ...obj,
            [gcode]: dataType === 'object' ? {value: dimName} : dimName,
            [_dcode]: dataType === 'object' ? {value: axisName} : axisName,
          })
        }
      })
    })
    // 对补全之后的数据再做笛卡尔集的指标数据处理
    bakList.forEach(item => {
      let catName = dataType === 'object' ? item[_dcode].value : item[_dcode]
      metCodeList.forEach(key => { // 遍历指标
        // 对笛卡尔集塞入对应的指标数据
        let _data = []
        bakList.forEach(subItm => {
          let subCatName = dataType === 'object' ? subItm[_dcode].value : subItm[_dcode]
          let subDimName = dataType === 'object' ? subItm[gcode].value : subItm[gcode]
          if (catName === subCatName) { // 对同一维度在对应分组的data数据位置塞入数据项
            // _data[dimention.indexOf(subDimName)] = subItm[key]
            _data[dimention.indexOf(subDimName)] = subItm[key]?.hasOwnProperty('value') ? subItm[key] : {
              ...subItm,
              value: subItm[key]
            }
          }
        })
        // 原始指标名称
        const name = (metrics.find(itm => itm.code === key) || {}).name
        const groupName = `${catName} ${name}` // 使用维度 + 指标作为显示指标数据的名称
        // 此算法存在冗余计算，临时处理方式，以分组 + 维度的笛卡尔集数据是否已生成作为判断条件，待优化
        if (!series.find(ser => ser.name === groupName && ser.stack === catName)) {
          series.push({
            name: groupName,
            originName: name, // 原始指标名称，在分组柱状图的tooltip中匹配使用的属性，目前没有更好的方法
            stack: catName, // 维度名称
            data: _data
          })
        }
      })
    })
    return {
      dimention: unitIndex ? dimention.map(dim => `${dim}${unitIndex}`) : dimention,
      series,
    };
  },
  generateAssistStr(metric, assistList, assistMetrics) {
    let str = ''
    metric?.set?.assistIndexs?.forEach((assItem, index) => {
      let formatVal = assistList[index]?.value || ''
      let assistMet = assistMetrics.find(assMet => (assMet.code === assItem.indexField || assMet.fieldKey === assItem.indexField)) || {}
      if (assItem.showVal === 'differPCT') {
        formatVal = `${formatVal.toFixed(2)}%`
      }
      if (assItem.showVal === 'differAbs') {
        formatVal = Math.abs(formatVal)
      }
      str += `<span
                  style="display:inline-block;margin-left: 16px"
                >
                  ${assistMet?.name} ${assItem.des || ''} ${formatVal} ${assistMet?.set?.indexUnit || ''}
                </span>`
    })
    return str
  },
  assistMetricsToolFormatter(params, prop, dataChart, series) {
    const {assistMetrics, metrics = [], metricsL = [], metricsR = []} = prop
    let res = "";
    params.forEach((v, i) => {
      const originName = (series.find(item => item.name === v.seriesName || item.name === v.name) || {}).originName
      const metric = [...metrics, ...metricsL, ...metricsR].find(met => v.seriesName === met.name || v.name === met.name || originName === met.name)
      // 分组的data和不分组的data顺序表示的内容不一样
      const assistList = prop?.groups?.length > 0 ? v.data?.assistList : (dataChart[v.dataIndex] && dataChart[v.dataIndex][metric.code] ? dataChart[v.dataIndex][metric.code]?.assistList : [])
      let str = this.generateAssistStr([...metrics, ...metricsL, ...metricsR], assistList, assistMetrics)
      res += `<div style="font-size: 12px">
                <div>${i == 0 ? v.name : ""}</div>
                ${
        v.value ?
          `<div style="display:flex;align-items:center">
                      ${v.marker}
                      <span>${v.seriesName}: ${v.value}  ${metric?.set?.indexUnit || ''}</span>
                      <span
                        style="display:inline-block;margin-left: 16px"
                      >
                      ${str}
                      </span>
                    </div>`
          : ''}
              </div>`;
    });
    return res;
  },
};
